export class PqrFomModalEntity{
    
    id:number;
    titleModal:string;
    paragraphTitleModal:string;
    identification:string;
    identificationFunction:string;
    serial:string;
    serialFunction:string;
    imei:string;
    imeiFunction:string;
    movil:string;
    movilFunction:string;
    description:string;
    descriptionFunction:string;
    filesAttachments:string;
    filesAttachmentsFuntion:string;
    filesAttachmentsButton:string;
    buttonOne:string;
    languegeId:string;
    creationDate:string;
    updateDate:string;
    active:string;
    language:string;
    constructor (){}
}